// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AppRouteImport } from './routes/_app'
import { Route as DesignRouteRouteImport } from './routes/design/route'
import { Route as EmailRouteImport } from './routes/email'
import { Route as MobileWebAuthRouteImport } from './routes/mobile-web-auth'
import { Route as PostMessageRouteImport } from './routes/post-message'
import { Route as RemoteRouteImport } from './routes/remote'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppAgentRouteImport } from './routes/_app/agent'
import { Route as AppAppsRouteImport } from './routes/_app/apps'
import { Route as AppBalancesRouteImport } from './routes/_app/balances'
import { Route as AppDepositFaqRouteImport } from './routes/_app/deposit-faq'
import { Route as DesignIndexRouteImport } from './routes/design/index'
import { Route as DesignFramesRouteImport } from './routes/design_.frames'
import { Route as DesignStripeRouteImport } from './routes/design_.stripe'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as SupportPrivacyPolicyRouteImport } from './routes/support/privacy-policy'
import { Route as SupportTermsOfServiceRouteImport } from './routes/support/terms-of-service'
import { Route as AppCreditsActivityRouteImport } from './routes/_app/credits.activity'
import { Route as RemoteAuthCliRouteImport } from './routes/remote/auth.cli'
import { Route as RemoteAuthDeviceRouteImport } from './routes/remote/auth.device'
import { Route as RemoteAuthMobileRouteImport } from './routes/remote/auth.mobile'
import { Route as RemoteRpcEth_sendTransactionRouteImport } from './routes/remote/rpc/eth_sendTransaction'
import { Route as RemoteRpcEth_sendTransactionSyncRouteImport } from './routes/remote/rpc/eth_sendTransactionSync'
import { Route as RemoteRpcEth_signTransactionRouteImport } from './routes/remote/rpc/eth_signTransaction'
import { Route as RemoteRpcEth_signTypedData_v4RouteImport } from './routes/remote/rpc/eth_signTypedData_v4'
import { Route as RemoteRpcPersonal_signRouteImport } from './routes/remote/rpc/personal_sign'
import { Route as RemoteRpcWallet_authorizeAccessKeyRouteImport } from './routes/remote/rpc/wallet_authorizeAccessKey'
import { Route as RemoteRpcWallet_connectRouteImport } from './routes/remote/rpc/wallet_connect'
import { Route as RemoteRpcWallet_depositRouteImport } from './routes/remote/rpc/wallet_deposit'
import { Route as RemoteRpcWallet_depositZoneRouteImport } from './routes/remote/rpc/wallet_depositZone'
import { Route as RemoteRpcWallet_revokeAccessKeyRouteImport } from './routes/remote/rpc/wallet_revokeAccessKey'
import { Route as RemoteRpcWallet_swapRouteImport } from './routes/remote/rpc/wallet_swap'
import { Route as RemoteRpcWallet_transferRouteImport } from './routes/remote/rpc/wallet_transfer'
import { Route as RemoteRpcWallet_updateAccessKeyRouteImport } from './routes/remote/rpc/wallet_updateAccessKey'
import { Route as RemoteRpcWallet_withdrawZoneRouteImport } from './routes/remote/rpc/wallet_withdrawZone'

const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const DesignRouteRoute = DesignRouteRouteImport.update({
            id: '/design',path: '/design',getParentRoute: () => rootRouteImport
          })
const EmailRoute = EmailRouteImport.update({
            id: '/email',path: '/email',getParentRoute: () => rootRouteImport
          })
const MobileWebAuthRoute = MobileWebAuthRouteImport.update({
            id: '/mobile-web-auth',path: '/mobile-web-auth',getParentRoute: () => rootRouteImport
          })
const PostMessageRoute = PostMessageRouteImport.update({
            id: '/post-message',path: '/post-message',getParentRoute: () => rootRouteImport
          })
const RemoteRoute = RemoteRouteImport.update({
            id: '/remote',path: '/remote',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppActivityRoute = AppActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AppRoute
          })
const AppAgentRoute = AppAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => AppRoute
          })
const AppAppsRoute = AppAppsRouteImport.update({
            id: '/apps',path: '/apps',getParentRoute: () => AppRoute
          })
const AppBalancesRoute = AppBalancesRouteImport.update({
            id: '/balances',path: '/balances',getParentRoute: () => AppRoute
          })
const AppDepositFaqRoute = AppDepositFaqRouteImport.update({
            id: '/deposit-faq',path: '/deposit-faq',getParentRoute: () => AppRoute
          })
const DesignIndexRoute = DesignIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DesignRouteRoute
          })
const DesignFramesRoute = DesignFramesRouteImport.update({
            id: '/design_/frames',path: '/design/frames',getParentRoute: () => rootRouteImport
          })
const DesignStripeRoute = DesignStripeRouteImport.update({
            id: '/design_/stripe',path: '/design/stripe',getParentRoute: () => rootRouteImport
          })
const SupportIndexRoute = SupportIndexRouteImport.update({
            id: '/support/',path: '/support/',getParentRoute: () => rootRouteImport
          })
const SupportPrivacyPolicyRoute = SupportPrivacyPolicyRouteImport.update({
            id: '/support/privacy-policy',path: '/support/privacy-policy',getParentRoute: () => rootRouteImport
          })
const SupportTermsOfServiceRoute = SupportTermsOfServiceRouteImport.update({
            id: '/support/terms-of-service',path: '/support/terms-of-service',getParentRoute: () => rootRouteImport
          })
const AppCreditsActivityRoute = AppCreditsActivityRouteImport.update({
            id: '/credits/activity',path: '/credits/activity',getParentRoute: () => AppRoute
          })
const RemoteAuthCliRoute = RemoteAuthCliRouteImport.update({
            id: '/auth/cli',path: '/auth/cli',getParentRoute: () => RemoteRoute
          })
const RemoteAuthDeviceRoute = RemoteAuthDeviceRouteImport.update({
            id: '/auth/device',path: '/auth/device',getParentRoute: () => RemoteRoute
          })
const RemoteAuthMobileRoute = RemoteAuthMobileRouteImport.update({
            id: '/auth/mobile',path: '/auth/mobile',getParentRoute: () => RemoteRoute
          })
const RemoteRpcEth_sendTransactionRoute = RemoteRpcEth_sendTransactionRouteImport.update({
            id: '/rpc/eth_sendTransaction',path: '/rpc/eth_sendTransaction',getParentRoute: () => RemoteRoute
          })
const RemoteRpcEth_sendTransactionSyncRoute = RemoteRpcEth_sendTransactionSyncRouteImport.update({
            id: '/rpc/eth_sendTransactionSync',path: '/rpc/eth_sendTransactionSync',getParentRoute: () => RemoteRoute
          })
const RemoteRpcEth_signTransactionRoute = RemoteRpcEth_signTransactionRouteImport.update({
            id: '/rpc/eth_signTransaction',path: '/rpc/eth_signTransaction',getParentRoute: () => RemoteRoute
          })
const RemoteRpcEth_signTypedData_v4Route = RemoteRpcEth_signTypedData_v4RouteImport.update({
            id: '/rpc/eth_signTypedData_v4',path: '/rpc/eth_signTypedData_v4',getParentRoute: () => RemoteRoute
          })
const RemoteRpcPersonal_signRoute = RemoteRpcPersonal_signRouteImport.update({
            id: '/rpc/personal_sign',path: '/rpc/personal_sign',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_authorizeAccessKeyRoute = RemoteRpcWallet_authorizeAccessKeyRouteImport.update({
            id: '/rpc/wallet_authorizeAccessKey',path: '/rpc/wallet_authorizeAccessKey',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_connectRoute = RemoteRpcWallet_connectRouteImport.update({
            id: '/rpc/wallet_connect',path: '/rpc/wallet_connect',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_depositRoute = RemoteRpcWallet_depositRouteImport.update({
            id: '/rpc/wallet_deposit',path: '/rpc/wallet_deposit',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_depositZoneRoute = RemoteRpcWallet_depositZoneRouteImport.update({
            id: '/rpc/wallet_depositZone',path: '/rpc/wallet_depositZone',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_revokeAccessKeyRoute = RemoteRpcWallet_revokeAccessKeyRouteImport.update({
            id: '/rpc/wallet_revokeAccessKey',path: '/rpc/wallet_revokeAccessKey',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_swapRoute = RemoteRpcWallet_swapRouteImport.update({
            id: '/rpc/wallet_swap',path: '/rpc/wallet_swap',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_transferRoute = RemoteRpcWallet_transferRouteImport.update({
            id: '/rpc/wallet_transfer',path: '/rpc/wallet_transfer',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_updateAccessKeyRoute = RemoteRpcWallet_updateAccessKeyRouteImport.update({
            id: '/rpc/wallet_updateAccessKey',path: '/rpc/wallet_updateAccessKey',getParentRoute: () => RemoteRoute
          })
const RemoteRpcWallet_withdrawZoneRoute = RemoteRpcWallet_withdrawZoneRouteImport.update({
            id: '/rpc/wallet_withdrawZone',path: '/rpc/wallet_withdrawZone',getParentRoute: () => RemoteRoute
          })





const DesignRouteRouteChildren = {
  DesignIndexRoute: DesignIndexRoute
}

const DesignRouteRouteWithChildren = DesignRouteRoute._addFileChildren(DesignRouteRouteChildren)




const AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,AppAgentRoute: AppAgentRoute,AppAppsRoute: AppAppsRoute,AppBalancesRoute: AppBalancesRoute,AppDepositFaqRoute: AppDepositFaqRoute,AppIndexRoute: AppIndexRoute,AppCreditsActivityRoute: AppCreditsActivityRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const RemoteRouteChildren = {
  RemoteAuthCliRoute: RemoteAuthCliRoute,RemoteAuthDeviceRoute: RemoteAuthDeviceRoute,RemoteAuthMobileRoute: RemoteAuthMobileRoute,RemoteRpcEth_sendTransactionRoute: RemoteRpcEth_sendTransactionRoute,RemoteRpcEth_sendTransactionSyncRoute: RemoteRpcEth_sendTransactionSyncRoute,RemoteRpcEth_signTransactionRoute: RemoteRpcEth_signTransactionRoute,RemoteRpcEth_signTypedData_v4Route: RemoteRpcEth_signTypedData_v4Route,RemoteRpcPersonal_signRoute: RemoteRpcPersonal_signRoute,RemoteRpcWallet_authorizeAccessKeyRoute: RemoteRpcWallet_authorizeAccessKeyRoute,RemoteRpcWallet_connectRoute: RemoteRpcWallet_connectRoute,RemoteRpcWallet_depositRoute: RemoteRpcWallet_depositRoute,RemoteRpcWallet_depositZoneRoute: RemoteRpcWallet_depositZoneRoute,RemoteRpcWallet_revokeAccessKeyRoute: RemoteRpcWallet_revokeAccessKeyRoute,RemoteRpcWallet_swapRoute: RemoteRpcWallet_swapRoute,RemoteRpcWallet_transferRoute: RemoteRpcWallet_transferRoute,RemoteRpcWallet_updateAccessKeyRoute: RemoteRpcWallet_updateAccessKeyRoute,RemoteRpcWallet_withdrawZoneRoute: RemoteRpcWallet_withdrawZoneRoute
}

const RemoteRouteWithChildren = RemoteRoute._addFileChildren(RemoteRouteChildren)

const rootRouteChildren = {
  DesignRouteRoute: DesignRouteRouteWithChildren,SplatRoute: SplatRoute,AppRoute: AppRouteWithChildren,EmailRoute: EmailRoute,MobileWebAuthRoute: MobileWebAuthRoute,PostMessageRoute: PostMessageRoute,RemoteRoute: RemoteRouteWithChildren,WelcomeRoute: WelcomeRoute,DesignFramesRoute: DesignFramesRoute,DesignStripeRoute: DesignStripeRoute,SupportPrivacyPolicyRoute: SupportPrivacyPolicyRoute,SupportTermsOfServiceRoute: SupportTermsOfServiceRoute,SupportIndexRoute: SupportIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)